"use client";
import type { ReactNode } from "react";

export function TelegramProvider({ children }: { children: ReactNode }) {
	// 暂时禁用Telegram登录功能
	return <>{children}</>;
}
